import axios from 'lib/axios'

export interface LuminaIdealProfilePreviewResponse {
  status: string
  data?: {
    validation: {
      ok: boolean
      readiness: string
      errors: string[]
      warnings: string[]
      detected: {
        nombre_rol?: string
        nivel?: string
        competencias_detectadas?: string[]
        demandas_detectadas?: string[]
      }
    }
    role: {
      nombre_proceso?: string
      tipo_proceso?: string
      nombre_rol?: string
      tipo_rol?: string
      nivel?: string
      competencias_clave?: string[]
      competencias_evaluadas?: string[]
      demandas_entorno?: string[]
    }
    betesa_ideal_profile: {
      alert_level_range: string[]
      alert_level_range_ids: number[]
      profile_values: Array<{
        quadrant: 'FI' | 'FD' | 'BI' | 'BD'
        priority: number
        min: number
        max: number
      }>
      structure?: {
        dominante?: string
        auxiliares?: string[]
        menos_eficiente?: string
      }
    }
    competences_ideal_profile: Array<{
      skill_id: number | null
      skill_name: string
      matched_skill_name: string | null
      weight: number
      priority: number
      matched: boolean
    }>
    skills_catalog?: Array<{
      id: number
      skill: string
    }>
    pdf_excerpt?: string
  }
  message?: string
}

interface PreviewPayload {
  file: File
  processName?: string
  processType?: string
  levelId?: number | null
  levelName?: string | null
}

const fetchIdealProfilePreview = async (
  payload: PreviewPayload,
): Promise<LuminaIdealProfilePreviewResponse> => {
  const body = new FormData()
  body.append('file', payload.file)

  if (payload.processName) {
    body.append('process_name', payload.processName)
  }

  if (payload.processType) {
    body.append('process_type', String(payload.processType))
  }

  if (payload.levelId) {
    body.append('level_id', String(payload.levelId))
  }

  if (payload.levelName) {
    body.append('level_name', payload.levelName)
  }

  try {
    const response = await axios.post(
      '/api/ai/ideal-profile/preview',
      body,
      {
        headers: {
          Authorization: localStorage.getItem('token'),
          'Content-Type': 'multipart/form-data',
        },
      },
    )

    return response.data
  } catch (error: any) {
    return {
      status: 'error',
      message:
        error?.response?.data?.message ||
        'No fue posible generar la sugerencia de perfil ideal.',
    }
  }
}

export default fetchIdealProfilePreview
